import { Link } from "react-router-dom";
import { cn } from "@/lib/utils";

export function LogoMark({ size = "md", to = "/", className, testid = "nav-logo" }) {
  const badge = size === "sm" ? "w-8 h-8 text-sm rounded-lg" : "w-10 h-10 text-base rounded-xl";
  const word = size === "sm" ? "text-base" : "text-lg";
  const inner = (
    <span className="flex items-center gap-2.5">
      <span className={cn("grid place-items-center font-heading font-black bg-gradient-to-br from-xd-blue to-xd-blueH text-xd-gold shadow-[0_6px_18px_rgba(46,107,255,0.45)] ring-1 ring-white/10", badge)}>XD</span>
      <span className={cn("font-heading font-black tracking-tight leading-none text-white", word)}>FREIGHT</span>
    </span>
  );
  return to ? <Link to={to} data-testid={testid} className={cn("group inline-flex", className)}>{inner}</Link> : <div className={cn("inline-flex", className)}>{inner}</div>;
}
